import { axios } from 'utils/networkRequests';
import useSnackbar from 'hooks/useSnackbar';
import { useHistory } from 'react-router';

const useResetPassword = () => {
  const history = useHistory();
  const snackbar = useSnackbar();
  return async (values) => {
    try {
      await axios.post('/v3/professional/accounts/request_reset_password', values, {
        headers: {
          accept: 'application/json',
        },
        withCredentials: true,
      });
      snackbar.success('If this email exists in our system, we have sent it a password reset link');
      history.push(`/login${history.location.search}`);
    } catch (error) {
      snackbar.error(error);
    }
  };
};

export default useResetPassword;
